// Same pattern Register.js and the old inquiry form use for client checks.
const EMAIL_RE =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const buildTaxidermyRegistration = (form) => {
  const payload = {
    title: form.salutation,
    first_name: form.firstName.trim(),
    last_name: form.lastName.trim(),
    email: form.email.trim(),
    password: form.password,
    country: Number(form.countryId),
  };
  const city = form.city.trim();
  if (city) {
    payload.city = city;
  }
  const mobile = form.mobilePhone.trim();
  if (mobile) {
    payload.mobile_phone = mobile;
  }
  // Most taxidermy buyers are private individuals; the API guide asks for
  // no organisation key at all in that case.
  if (form.representsCompany) {
    const name = form.companyName.trim();
    if (name) {
      payload.organisation = { name };
    }
    const phone = form.companyPhone.trim();
    if (phone) {
      payload.phone = phone;
    }
  }
  return payload;
};

// Values are keys into languages/langs.js so the component renders them
// in the visitor's language.
export const validateRegistration = (form) => {
  const errors = {};
  if (!form.firstName.trim()) {
    errors.first_name = "err_required";
  }
  if (!form.lastName.trim()) {
    errors.last_name = "err_required";
  }
  if (!EMAIL_RE.test(form.email.trim())) {
    errors.email = "err_email";
  }
  if (form.password.length < 8) {
    errors.password = "err_password_length";
  } else if (form.password !== form.passwordRepeat) {
    errors.password_repeat = "passwd_mismatch";
  }
  if (form.countryId === "empty") {
    errors.country = "err_required";
  }
  if (form.representsCompany) {
    if (!form.companyName.trim()) {
      errors.organisation_name = "err_required";
    }
    const phone = form.companyPhone.trim();
    if (phone && phone.length < 10) {
      errors.phone = "err_phone_length";
    }
  }
  return errors;
};
